
import Radio from 'vux/src/components/radio/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import cookie from 'vux/src/tools/cookie/index.js'
import Loading from 'vux/src/components/loading/index.vue'

import { BANKS } from '@/utils/constants'
import { isNeedBank, numberWithCommas } from '@/utils/helpers'

export default {
components: {
Group,
Cell,
ViewBox,
XHeader,
XButton,
Box,
XInput,
PopupRadio,
Popup,
Radio,
Loading
},
beforeCreate: function () {
document.body.className = 'charge deposit2 dark'
},
data () {
return {
typeoption: [],
typeid: null,
channels: [],
channelsfilter: [],
channel_key: null,
showChannel: false,
banksoption: [],
banksfilter: [],
bank_key: null,
needBank: null,
showBank: false,
havebankid: false,
titlechoose: 'Chọn ngân hàng',
channeldesc: '',
channelmin: null,
success_rate: null,
channelmax: null,
orientpos: false,
rotate: false,
query: '',
title: '充值',
platform_show: {
desc: ''
},
amount: 0,
name: '',
amount_index: -1,
input_amount: '',
confirm: {
show: false
},
showTypeSelect: false,
code: null,
serial: null,
need_bank: null,
need_scratchcard: 0,
bank_id: null,
showPayPage: false,
load_url: '',
qrcode: null,
info: {
nickname: '',
usable_gold: '',
freeze_gold: '',
financal: {
status: 0
}
},
show_list: true,
pay_click: false,
showAmountInput: false,
platform_name: '',
app_order_no: '',
order_no: '',
show_amount: 0,
bank_card_no: '',
platform_type: '',
show_amount_input: true,
videoon: false,
videooff: true,
popvid: false,
need_name: false
}
},
watch: {
'platform': function (newVal, oldVal) {
if (newVal !== oldVal) {
this.checkBank()
}
},
'amount': function () {
if (this.amount > 0) {
this.input_amount = ''
}
},
'input_amount': function () {
if (this.input_amount > 0) {
this.amount = 0
}
},
'$route.query.order_no': function () {
window.location.reload()
}
},
mounted () {
this.handleOrientationChange()
window.addEventListener('orientationchange', this.handleOrientationChange)
this.checkOrderCounts()
const self = this
self.channel_key = typeof self.$route.query.platform_id === 'undefined'
? 1 : JSON.parse(self.$route.query.platform_id)


self.$models.Deposit.info({
order_no: self.$route.query.order_no,
valid: self.$route.query.valid
}).then(function (typePlatforms) {
self.checkDepositExists(typePlatforms.data.data)
self.rotate = typePlatforms.data.data.rotate_prompt
for (let typePlatform of typePlatforms.data.data.types) {
var typelist = {
key: typePlatform.type_id,
value: typePlatform.display_name,
icon: `static/images/logo/${typePlatform.icon}.png`,
isfeatured: typePlatform.is_featured
}
var channellist
if (!(isNeedBank(typePlatform.type_id))) {
for (let typemobileshow of typePlatform.data) {
var showmobile, defaultmobile
showmobile = typemobileshow.mobile_show
defaultmobile = typemobileshow.mobile_default
channellist = {
show_view: Boolean(showmobile),
default_show: Boolean(defaultmobile),
key: typemobileshow.id,
value: typemobileshow.name,
bank_id: typemobileshow.bank_id,
banks: typemobileshow.banks,
amount_list: typemobileshow.custom_amounts,
description: typemobileshow.description,
icon: `static/images/logo/${typemobileshow.icon}.png`,
max_load: typemobileshow.max_load,
min_load: typemobileshow.min_load,
need_bank: typemobileshow.need_bank,
static_amount: typemobileshow.static_amount,
type_id: typemobileshow.type_id,
need_scratchcard: typemobileshow.need_scratchcard,
success_rate: typemobileshow.success_rate,
need_name: typemobileshow.need_name
}
self.channels = self.channels.concat(channellist)
}
self.typeoption = self.typeoption.concat(typelist)
} else {
for (let typemobileshow of typePlatform.data) {
let bankshortname = BANKS[typemobileshow.icon]
if (bankshortname === '' || bankshortname === undefined) {
bankshortname = typemobileshow.name
}
var banklist = {
key: typemobileshow.icon,
value: bankshortname,
icon: `static/images/vnbanks/icons/${typemobileshow.icon}.png`,
children: typemobileshow.children,
type_id: typePlatform.type_id
}
for (let typemobileshow2 of typemobileshow.children) {
showmobile = typemobileshow2.mobile_show
defaultmobile = typemobileshow2.mobile_default
channellist = {
show_view: Boolean(showmobile),
default_show: Boolean(defaultmobile),
key: typemobileshow2.id,
value: typemobileshow2.name,
bank_id: typemobileshow2.bank_id,
banks: typemobileshow2.banks,
amount_list: typemobileshow2.custom_amounts,
description: typemobileshow2.description,
icon: `static/images/logo/${typemobileshow2.icon}.png`,
max_load: typemobileshow2.max_load,
min_load: typemobileshow2.min_load,
need_bank: typemobileshow2.need_bank,
static_amount: typemobileshow2.static_amount,
type_id: typemobileshow2.type_id,
related_bankid: typemobileshow.icon,
related_bankname: typemobileshow.name,
need_scratchcard: typemobileshow2.need_scratchcard,
success_rate: typemobileshow2.success_rate,
need_name: typemobileshow2.need_name
}
self.channels = self.channels.concat(channellist)
}
self.banksoption = self.banksoption.concat(banklist)
}
self.typeoption = self.typeoption.concat(typelist)
}
}
if (['', null, '0.00'].includes(typePlatforms.data.data.amount)) {
self.showAmountInput = true
} else {
self.showAmountInput = false
self.show_amount = typePlatforms.data.data.amount
}
self.app_order_no = typePlatforms.data.data.app_order_no
if (self.typeoption.length === 0) {
self.$router.replace({
path: '/error',
query: {
title: 'Ngân hàng này đang bảo trì.<br />Vui lòng quay lại sau.',
description1: `Đặt hàng：${typePlatforms.data.data.app_order_no}`,
description2: `Các loại thanh toán： ${(typePlatforms.data.data.type === null) ? 'Không có kênh nào tại thời gian này' : typePlatforms.data.data.type}`
}
})
} else if (self.typeoption.length === 1) {
self.typeid = self.typeoption[0]['key']
if (typePlatforms.data.data.bank_id === null) {
self.havebankid = false
self.listChannel(self.typeid)
if (!(self.showAmountInput === true || (isNeedBank(self.typeid) && self.banksfilter.length > 1) || self.channelsfilter.length > 1)) {
self.check()
}
} else {
self.havebankid = true
self.bank_key = typePlatforms.data.data.bank_id
self.listChannel(self.typeid)
self.listbankchannel(typePlatforms.data.data.bank_id)
if (!(self.showAmountInput === true || self.channelsfilter.length > 1)) {
self.check()
}
}
} else if (self.typeoption.length > 1) {
self.typeid = self.typeoption[0]['key']
self.listChannel(self.typeid)
if (isNeedBank(self.typeid)) {
self.listbankchannel(self.banksfilter[0]['key'])
self.bank_key = self.banksfilter[0]['key']
}
}
})

sessionStorage.setItem('prev', this.$route.fullPath)
},
methods: {
checkDepositExists (orderInfo) {

if (orderInfo === undefined || orderInfo === '') {
this.$router.replace({
path: '/error',
query: {
title: 'Đơn hàng không tồn tại',
description1: 'Lỗi'
}
})
}

const { has_deposit: hasDeposit, app_order_no: appOrderNumber } = orderInfo
if (hasDeposit) {
this.$router.replace({
path: '/error',
query: {
title: 'Đơn hàng đã tồn tại',
description1: `Đặt hàng：${appOrderNumber}`
}
})
}
},
handleOrientationChange () {
const isRotate = (window.screen.orientation && window.screen.orientation.angle > 0) || !window.matchMedia('(orientation: portrait)').matches

this.orientpos = /Android|iPhone|iPad|iPod|iOS|BlackBerry|IEMobile/i.test(navigator.userAgent)
? isRotate : false
},
closeIt () {
this.orientpos = false
},

helpcenter () {
this.videoon = true
this.videooff = false
},
backtomain () {
this.videoon = false
this.videooff = true
},
closevid () {
var video = document.getElementById('videoinfo')
video.removeAttribute('src')
this.popvid = false
},
viewvideo (videoname) {
this.popvid = true
setTimeout(function () {
var video = document.getElementById('videoinfo')
video.setAttribute('type', 'video/mp4')
video.setAttribute('src', `static/images/helpcenter/${videoname}.mp4`)
video.load()
video.play()
}, 500)
},


listChannel (typeid) {
this.typeid = typeid
if (!(isNeedBank(typeid))) {
this.showChannel = true
this.channel_key = null
this.bank_key = null
this.channelsfilter = []
this.showBank = false
this.banksfilter = []
this.channelmin = null
this.channelmax = null
this.success_rate = null
this.showTypeSelect = false
this.need_scratchcard = null
this.need_name = false
for (let channelshow of this.channels) {
if (typeid === channelshow.type_id) {
this.channelsfilter = this.channelsfilter.concat(channelshow)
if (channelshow.default_show) {
this.channel_key = channelshow.key
this.channelmin = channelshow.min_load
this.channelmax = channelshow.max_load
this.needBank = channelshow.need_bank
this.channeldesc = channelshow.description
this.need_scratchcard = channelshow.need_scratchcard
this.success_rate = channelshow.success_rate
this.need_name = channelshow.need_name
} else {
this.channel_key = this.channelsfilter[0]['key']
this.channelmin = this.channelsfilter[0]['min_load']
this.channelmax = this.channelsfilter[0]['max_load']
this.needBank = this.channelsfilter[0]['need_bank']
this.channeldesc = this.channelsfilter[0]['description']
this.need_scratchcard = this.channelsfilter[0]['need_scratchcard']
this.success_rate = this.channelsfilter[0]['success_rate']
this.need_name = this.channelsfilter[0]['need_name']
}
}
}
} else {
this.showBank = false
this.banksfilter = []
if (typeid === 14) {
this.titlechoose = 'Chọn loại thẻ'
this.handleLoadCardTypeSelect()
} else {
this.titlechoose = 'Chọn ngân hàng'
this.showTypeSelect = false
this.code = null
this.serial = null
}
if (this.havebankid === false) {
for (let bankshow of this.banksoption) {
if (typeid === bankshow.type_id) {
this.banksfilter = this.banksfilter.concat(bankshow)
}
}
this.bank_key = this.banksfilter[0]['key']
this.listbankchannel(this.bank_key)
} else {
for (let bankshow of this.banksoption) {
if (typeid === bankshow.type_id && this.bank_key === bankshow.key) {
this.banksfilter = this.banksfilter.concat(bankshow)
}
}
}
this.showBank = true
this.showChannel = true
}
},
listbankchannel (bankkey) {
this.showChannel = false
this.channel_key = null
this.channelsfilter = []
this.channelmin = null
this.channelmax = null
this.needBank = null
this.need_scratchcard = null
this.success_rate = null
this.need_name = false
for (let bankchannelshow of this.channels) {
if (bankchannelshow.type_id === this.typeid && bankchannelshow.related_bankid === bankkey) {
this.channelsfilter = this.channelsfilter.concat(bankchannelshow)
if (bankchannelshow.default_show) {
this.channel_key = bankchannelshow.key
this.channelmin = bankchannelshow.min_load
this.channelmax = bankchannelshow.max_load
this.needBank = bankchannelshow.need_bank
this.channeldesc = bankchannelshow.description
this.need_scratchcard = bankchannelshow.need_scratchcard
this.success_rate = bankchannelshow.success_rate
this.need_name = bankchannelshow.need_name
} else {
this.channel_key = this.channelsfilter[0]['key']
this.channelmin = this.channelsfilter[0]['min_load']
this.channelmax = this.channelsfilter[0]['max_load']
this.needBank = this.channelsfilter[0]['need_bank']
this.channeldesc = this.channelsfilter[0]['description']
this.need_scratchcard = this.channelsfilter[0]['need_scratchcard']
this.success_rate = this.channelsfilter[0]['success_rate']
this.need_name = this.channelsfilter[0]['need_name']
}
}
}
if (bankkey !== null) {
this.showChannel = true
}
},
channelselect (channelkey) {
for (let selectchannel of this.channels) {
if (this.bank_key === null) {
if (this.typeid === selectchannel.type_id && channelkey === selectchannel.key) {
this.channelmin = selectchannel.min_load
this.channelmax = selectchannel.max_load
this.needBank = selectchannel.need_bank
this.channeldesc = selectchannel.description
this.need_scratchcard = selectchannel.need_scratchcard
this.success_rate = selectchannel.success_rate
this.need_name = selectchannel.need_name
}
} else {
if (this.typeid === selectchannel.type_id && channelkey === selectchannel.key && this.bank_key === selectchannel.related_bankid) {
this.channelmin = selectchannel.min_load
this.channelmax = selectchannel.max_load
this.needBank = selectchannel.need_bank
this.channeldesc = selectchannel.description
this.need_scratchcard = selectchannel.need_scratchcard
this.success_rate = selectchannel.success_rate
this.need_name = selectchannel.need_name
this.handleLoadCardTypeSelect()
}
}
}
},

check () {
this.$vux.loading.show({
text: 'Loading'
})
var submitAmout = Math.max(this.amount, this.input_amount)
submitAmout = Math.max(this.show_amount, submitAmout)
var minLoad = this.channelmin
var maxLoad = this.channelmax
if (this.bank_key === null && (this.typeid === 12 || this.typeid === 13)) {
this.$vux.loading.hide()
this.$vux.toast.show({
'text': 'Vui lòng chọn ngân hàng！',
'type': 'warn'
})
return
}

if (this.bank_key === null && (this.typeid === 14)) {
this.$vux.loading.hide()
this.$vux.toast.show({
'text': 'Vui lòng chọn loại thẻ！',
'type': 'warn'
})
return
}
if (this.showTypeSelect === true && (this.code === null || this.code.trim() === '' || this.serial === null || this.serial.trim() === '')) {
this.$vux.loading.hide()
this.$vux.toast.show({
'text': 'Vui lòng nhập Mã thẻ và số seri！',
'type': 'warn'
})
return
}

if (this.need_name && this.name === '') {
this.$vux.loading.hide()
this.$vux.toast.show({
'text': 'Vui lòng nhập tên thật！',
'type': 'warn'
})
return
}
if (submitAmout >= minLoad && submitAmout <= maxLoad) {
this.submit(submitAmout)
} else {
this.$vux.loading.hide()
this.$vux.alert.show({
content: 'Hỗ trợ nạp tiền ' + minLoad + 'VND ~ ' + maxLoad + ' VND '
})
}
},
generalDepositCreateParams (amount) {
const self = this
return {
order_no: self.$route.query.order_no,
valid: self.$route.query.valid,
platform_id: self.channel_key,
bank_id: self.bank_key,
name: self.name,
amount,
bank_card_no: self.bank_card_no
}
},
vinaPhoneCardDepositCreateParams (amount) {
const self = this
return {
order_no: self.$route.query.order_no,
valid: self.$route.query.valid,
platform_id: self.channel_key,
bank_id: self.bank_key,
name: self.name,
amount,
serial: self.serial,
code: self.code,
type: self.bank_key
}
},
submit (submitAmout) {
const self = this
self.pay_click = true
const params = this.need_scratchcard
? this.vinaPhoneCardDepositCreateParams(submitAmout)
: this.generalDepositCreateParams(submitAmout)

self.$models.Deposit.create(params).then(function (response) {
self.pay_click = false
if (!response.data.success) {
self.$vux.loading.hide()
self.$router.replace({
path: '/error',
query: {
title: response.data.message,
description1: 'Đặt hàng：' + self.app_order_no,
description2: 'Kênh số：#' + self.channel_key,
description3: ''
}
})
return
}
cookie.remove('historys')
self.load_url = response.data.data.load_url
if (response.data.data.load_straight === 1) {
window.location.href = self.load_url
return
} else if (response.data.data.load_straight === 2) {
self.$router.replace({
path: './qrcode',
query: {
qrcode: response.data.data.load_url,
deposit_type: response.data.data.deposit_type,
platform_id: self.channel_key,
from_url: self.$route.path
}
})
return
}
if (self.need_scratchcard && self.typeid === 14) {
self.$router.replace({ path: '/finished' })
return
}

self.showPayPage = true
setTimeout(() => {
self.$vux.loading.hide()
}, 2000)
})
},
showAsk () {
const self = this
self.$vux.confirm.show({
content: 'Vui lòng hoàn tất thanh toán trong cửa sổ mở mới<br />Nếu đã hoàn tất, hãy nhấp vào "hoàn tất thanh toán"',
confirmText: 'Hoàn tất thanh toán',

onCancel () {
},
onConfirm () {
self.payComplete()
}
})
},
showContent (platform) {
const self = this
if (platform.show) {
self.show_list = false
switch (platform.show.type) {
case 'qr':
self.showQrCode(platform)
break
case 'url':
self.showUrl(platform)
break
}
} else {
self.show_list = true
}
},
showQrCode (platform) {
const self = this
self.platform_show = platform.show
},
showUrl (platform) {
const self = this
self.platform_show = platform.show
},
navToPay () {
const self = this
window.location.href = self.platform_show.link
},
payComplete () {
const self = this
self.showPayPage = false
self.$router.replace({
path: '/deposit/list'
})
},
checkOrderCounts () {
const history = cookie.get('historys')
if (typeof history !== 'undefined') {
console.log('historys in 5mins count:' + Object.keys(JSON.parse(history)).length)
if (Object.keys(JSON.parse(history)).length > 50) {
this.$router.replace({
path: '/error',
query: {
title: 'Đơn đặt hàng được bắt đầu quá thường xuyên',
description1: 'Xin lỗi vì bạn thường xuyên đặt hàng nhưng không gửi thanh toán',
description2: 'Xin vui lòng mất năm phút nghỉ để thử lại, cảm ơn bạn đã hợp tác của bạn'
}
})
return false
}
}

if (typeof this.$route.query.order_no !== 'undefined') {
this.setOrderCounts()
}
},
setOrderCounts () {
var historys = {}
if (typeof cookie.get('historys') !== 'undefined') {
historys = JSON.parse(cookie.get('historys'))
console.log(historys)
}

historys[this.$route.query.order_no] = true

var expire = new Date()
expire.setMinutes(expire.getMinutes() + 5)
cookie.set('historys', JSON.stringify(historys), {
expires: expire,
raw: true
})
},
numberWithCommas,
handleLoadCardTypeSelect () {
this.code = null
this.serial = null
this.showTypeSelect = this.typeid === 14 && this.need_scratchcard === 1
}
}
}



// WEBPACK FOOTER //
// ./src/components/Deposit2Dark.vue